import { SecureBufferE } from "./SecureBufferE";

export function SecureBufferEW(wsMgr, theBuffer, encodeBuffer) {
  var org = wsMgr.GetAccountName();
  var user = wsMgr.GetUserName();
  return SecureBufferE(org, user, theBuffer);
}
